import { useCallback } from 'react';

import { useAnnotationCounts } from '@/contexts/AnnotationCountsContext';
import { useSensorsContext } from '@/contexts/SensorsContext';

import { useSensors } from './useSensors';

export function useExitSession(isHubFlow: boolean) {
  const { disconnectAll, resetDeletedAnnotations, resetTags, resetSession } = useSensors(isHubFlow);
  const { resetAnnotations } = useAnnotationCounts();
  const { reset } = useSensorsContext();

  const exit = useCallback(() => {
    // Reset the stores
    reset();
    resetAnnotations();

    // Disconnect all the sensors
    disconnectAll();

    // Reset the swift layer
    resetDeletedAnnotations();
    resetTags();
    resetSession();
  }, []);

  return {
    exit,
  };
}
